import React from "react";
import { Box, Typography, TextField, Grid } from "@mui/material";
import MultipleImageUpload from "../media/multipleimageupload";

const DivePhotoUploader = ({ diveImages, setDiveImages }) => {
  const handleMultipleImageChange = (newImages) => {
    // Limit to 2 images maximum
    if (newImages.length > 2) {
      alert("Maximum of 2 images allowed");
      return;
    }
    setDiveImages(newImages);
  };

  const handleImageDescriptionChange = (index, value) => {
    const updatedImages = diveImages.map((item, i) =>
      i === index ? { ...item, description: value } : item
    );
    setDiveImages(updatedImages);
  };

  return (
    <Box p={2} border="1px solid lightgrey" borderRadius={1}>
      <Typography gutterBottom>Dive Photos (max 2):</Typography>
      <MultipleImageUpload
        name="diveImages"
        onImageChange={handleMultipleImageChange}
        value={diveImages}
        maxFiles={2}
      />
      {diveImages.length > 0 && (
        <Box mt={2}>
          <Typography variant="subtitle2" gutterBottom>
            Add descriptions:
          </Typography>
          <Grid container spacing={2}>
            {diveImages.map((imageItem, index) => (
              <Grid item xs={12} key={index}>
                <TextField
                  label={`Description for image ${index + 1}`}
                  value={imageItem.description || ""}
                  onChange={(e) =>
                    handleImageDescriptionChange(index, e.target.value)
                  }
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  size="small"
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default DivePhotoUploader;
